export const TOGGLE_PROGRAM_DETAIL = 'TOGGLE_PROGRAM_DETAIL';
